import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import { push } from 'react-router-redux';

import { tryToResetPassword } from '../actions/actions.export.js';
import Button from '../components/Button/Button.js'
import CustomField from '../components/CustomField/CustomField.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'

class ResetPassword extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      new_password: props.user.resetPasswordForm.lastSubmit.new_password,
      new_password_verify: props.user.resetPasswordForm.lastSubmit.new_password_verify
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e){
    const { dispatch } = this.props; 
    dispatch(tryToResetPassword({
      new_password: this.state.new_password,
      new_password_verify: this.state.new_password_verify,
      code: this.props.match.params.code
    }));
    if(e) e.preventDefault();
  }

  componentDidMount(){
    const { dispatch, user } = this.props;
    if(user.isLoggedIn){
      // try to confirm email
      dispatch(push('/404'));
    }
  }

  componentDidMount(){
    window.document.title = "Reset Password - Pattycake";
  }


  render(){
    const { dispatch, user } = this.props;
    const state = this.state;

    let formDisabled = !state.new_password || !state.new_password_verify;

    return <div className="landing">

      {
        user.isLoggedIn ? (
          <div className="dead-center">
            <i className="far fa-spinner-third fa-spin fa-4x text-primary"/>
          </div>
        ) : ('')
      }

      {
        !user.isLoggedIn ? (
          <div className="body-stretch">
          <Header transparent={true}/>
          <div className="stretched">
            <div className="container">
              <div className="row justify-content-center row-mega-padded">
                <div className="col-md-4">
                  <h1 className="text-center">
                    Reset Password
                  </h1>
                  <p className="lead text-center p-push-down">We're forgetful too.</p>
          
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    if(!formDisabled) this.handleSubmit(e); 
                  }}>

                    <CustomField 
                      type="password"
                      name="new_password"
                      placeholder="new password"
                      label="New Password"
                      onChange={(e) => {this.setState({new_password: e}); }}
                      serverErrors={user.resetPasswordForm.errors.mew_password}
                      required={true}
                      minLength={8}
                      disabled={user.tryingToResetPassword}
                    />

                    <CustomField 
                      type="password"
                      name="new_password_verify"
                      placeholder="just to double check"
                      label="New Password Again"
                      onChange={(e) => {this.setState({new_password_verify: e}); }}
                      serverErrors={user.resetPasswordForm.errors.new_password_verify}
                      required={true}
                      minLength={8}
                      disabled={user.tryingToResetPassword}
                      clientValidation={(v)=> {
                        console.log(v, state.new_password);
                        if(v != state.new_password){
                          return 'Does not match.'
                        }
                        return false;
                      }}
                    />

                    <div className="text-center">
                      <br/>
                      <Button 
                        submit={true}
                        disabled={formDisabled} 
                        thinking={user.tryingToResetPassword} 
                        succesful={user.successfullyResetPassword}
                        failed={user.failedToResetPassword}
                        onClick={this.handleSubmit} 
                        display="Set Password" 
                        size="large" 
                        color="success"
                        block={true}
                      />
                      <br/>
                    </div>
                    <p className="text-danger text-center">
                      {
                        user.resetPasswordForm.errors.code
                      }
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <Footer/>
        </div>
        ) : ('')
      }
    </div>
  }

}



ResetPassword = reduxForm({
  form: 'ResetPassword',
  enableReinitialize: true,
  destroyOnUnmount: false
})(ResetPassword)

ResetPassword = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    initialValues
  }
})(ResetPassword);

export default ResetPassword;




// WEBPACK FOOTER //
// ./src/routes/ResetPassword.js